import React from "react";
import "../scss/Elements/_tables.scss";
import { Helmet } from "react-helmet";
import { useTranslationHook } from "../hooks/UseTranslationHook";
import { RolesTable } from "../components/Tables/RolesTable";

function ListRoles() {
  const { titleRolesString } = useTranslationHook();

  return (
    <div className="table-module-container">
      <Helmet>
        <title>{titleRolesString}</title>
      </Helmet>
      <div className="datatable">
        <RolesTable />
      </div>
    </div>
  );
}
export default ListRoles;